import { loadScript } from '@mtfe/sweet-utils';

const HREF = window.location.href;
const SUPPORT_DOMAIN = ['st.meituan.com'];

(() => {
    if (SUPPORT_DOMAIN.some((domain) => HREF.includes(domain))) {
        loadScript('https://unpkg.com/vconsole@latest/dist/vconsole.min.js', {}, (error) => {
            if (error) {
                console.error(error);
                return;
            }
            if (window.VConsole) {
                // eslint-disable-next-line no-new
                new window.VConsole();
            }
        });
    }
})();
